/** Marks a control inside a row whose click is the row's own click. */
export const ROW_OPEN_ATTRIBUTE = "data-row-open"

const IGNORE_SELECTOR =
  "button, a, input, textarea, .ant-select, .ant-dropdown, .ant-dropdown-trigger, .ant-upload, .ant-popover, .ant-checkbox, [data-stop-row-click]"

/**
 * Whether a click on an invoice row belongs to a control inside it rather than
 * to the row. Popovers and menus portal to the body but still bubble through
 * the React tree, so a target outside the row is not the row's click either.
 */
export const isInvoiceRowClickIgnored = (
  target: HTMLElement | null,
  row: HTMLElement
): boolean => {
  if (!target || !row.contains(target)) return true
  if (target.closest(`[${ROW_OPEN_ATTRIBUTE}]`)) return false
  return Boolean(target.closest(IGNORE_SELECTOR))
}
